




































































































































































































































































































































import Vue from 'vue';
import { FormRules } from '@/mixins/FormRules';
import mixins from '@/utils/mixins';
import returnable from '@/mixins/returnable';
import resourceable, { EMTPYRESOURCE } from '@/mixins/resourceable';

export default mixins(Vue, returnable, resourceable).extend({
  mixins: [FormRules],
  props: {
    title: { type: String, default: 'title' }
  },
  data() {
    return {
      isActive: false,
      labels: {
        create: 'Create',
        save: 'Save',
        edit: 'Edit'
      },
      itemImage: '' as any,
      titleItems: [
        {
          value: 'Mr.',
          display_name: 'Mr.'
        },
        {
          value: 'Mrs.',
          display_name: 'Mrs.'
        },
        {
          value: 'Miss',
          display_name: 'Miss'
        },
        {
          value: 'Ms.',
          display_name: 'Ms.'
        },
        {
          value: 'Dr.',
          display_name: 'Dr.'
        },
        {
          value: 'Rev.',
          display_name: 'Rev.'
        }
      ]
    };
  },
  watch: {
    isActive(val) {
      if (val) {
        this.$emit('open');
        // setTimeout(this.focus, 50); // Give DOM time to paint
      } else {
        this.$emit('close');
      }
    }
  },
  methods: {
    open(resource?: any) {
      console.log('OPENED');
      if (resource) {
        this.resource = resource;
      }
      if (!resource && this.module === 'genericWithName') {
        this.resource.name = {
          title: '',
          first: '',
          last: ''
        };
      }
      this.isActive = true;
    },
    onChange(e: any): void {
      try {
        const reader = new FileReader();
        const files = e.target.files || e.dataTransfer.files;
        // this.itemsAdded = files.length;
        reader.onload = (e: ProgressEvent<FileReader>) => {
          this.itemImage = e.target?.result;
        };
        reader.readAsDataURL(files[0]);
        this.resource.avatar = files[0];
      } catch (e) {
        console.log(e);
      }
    },
    cancel() {
      this.isActive = false;
      this.clearData();

      this.$emit('cancel');
    },
    async clearData() {
      await setTimeout(() => {
        this.itemImage = '';
        this.resource = Object.assign(this.resource, EMTPYRESOURCE);
      }, 250);
    },
    async saveDialog() {
      // await this.save(this.returnValue);
      setTimeout(() => {
        this.isActive = false;
      });
      await this.$emit('save', this.resource);
      // await this.clearData();
    }
  }
});
